<script>

// user-scalable=0 for ios 10+ safari
(function() {
    // document.addEventListener('touchmove', (event) => {
    //     if (event.scale !== 1) {
    //         event.preventDefault();
    //     }
    // }, false);

    // let lastTouchEnd = 0;
    // document.addEventListener('touchend', (event) => {
    //     const now = (new Date()).getTime();
    //     if (now - lastTouchEnd <= 300) {
    //         event.preventDefault();
    //     }
    //     lastTouchEnd = now;
    // }, false);

    // document.addEventListener('gesturestart touchmove', function (evt) {
    //     if (evt.scale !== 1) {
    //         evt.preventDefault()
    //         document.body.style.transform = 'scale(1)'
    //     }
    // });
})();

export default {
    name: 'Hacks'
}
</script>

<style lang="scss"></style>
